import PeregrineContextProvider from '@/PeregrineContextProvider';
import { ToastContextProvider } from '@/hooks/Toasts';
import LocaleProvider from './localeProvider';

const contextProviders = [LocaleProvider, PeregrineContextProvider, ToastContextProvider];

const ContextProvider = ({ children }) => {
  return contextProviders.reduceRight((memo, ContextProvider) => {
    return <ContextProvider>{memo}</ContextProvider>;
  }, children);
};

export default ContextProvider;
